import {FC} from 'react';

import ReasonRejectionCode from '../../../components/Dictionaries/ReasonRejections/reason-rejection';

const ReasonRejectionPage: FC = () => {
  return (
    <div>
      <ReasonRejectionCode />
    </div>
  );
};

export default ReasonRejectionPage;
